import React from 'react';
import LongText from '../../../Elements/LongText';
import TpPlatformInvoiceLineItem from './TpPlatformInvoiceLineItem';

// "Assignment" tab of the platform-invoice detail popup: ShopInstance rows only, so the
// Cost Type / Quantity columns are dropped and the count is labelled as shops. Rate and
// Amount stay empty on Prism NA — the platform sends no assignment dollars there.
export default class TpPlatformInvoiceAssignmentItem extends TpPlatformInvoiceLineItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Billing Code',
        orderById: 'ThirdPartyBillingCode',
        data: 'ThirdPartyBillingCode',
        minWidth: 50,
      },
      {
        label: 'TP Client ID',
        orderById: 'ThirdPartyClientId',
        data: 'ThirdPartyClientId',
        className: 'text-center',
        minWidth: 40,
      },
      {
        label: 'Company',
        orderById: 'ThirdPartyCompany',
        data: (d) => (
          <LongText
            text={d.ThirdPartyCompany}
            maxLength={30}
          />
        ),
        className: 'text-left',
        minWidth: 80,
      },
      {
        label: 'Caspian Client',
        orderById: '',
        data: (item) => TpPlatformInvoiceLineItem.getCaspianClientCellContent(item),
        className: 'text-left',
        minWidth: 80,
      },
      {
        label: 'Office',
        orderById: '',
        data: 'OfficeName',
        className: 'text-left',
        minWidth: 50,
      },
      {
        label: 'Shop Count',
        orderById: '',
        data: 'ThirdPartyItemCount',
        className: 'text-center',
        minWidth: 30,
      },
      {
        label: 'Rate',
        orderById: '',
        data: 'ThirdPartyRate',
        className: 'text-right',
        minWidth: 30,
      },
      {
        label: 'Amount',
        orderById: '',
        data: 'ThirdPartyAmount',
        className: 'text-right',
        minWidth: 40,
      },
    ];
  }
}
